import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Hp2 from "@/pages/Hp2";
import Hp3 from "@/pages/Hp3";
import Hp4 from "@/pages/Hp4";
import PdpConcept from "@/pages/PdpConcept";
import PdpConceptV2 from "@/pages/PdpConceptV2";
import PdpConceptV3 from "@/pages/PdpConceptV3";
import PdpConceptV31 from "@/pages/PdpConceptV31";
import PdpConceptV32 from "@/pages/PdpConceptV32";
import PdpConceptV33 from "@/pages/PdpConceptV33";
import PdpConceptV34 from "@/pages/PdpConceptV34";
import PasswordGate from "@/components/PasswordGate";

function App() {
  return (
    <div className="App">
      <PasswordGate>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hp2" element={<Hp2 />} />
            <Route path="/hp3" element={<Hp3 />} />
            <Route path="/hp4" element={<Hp4 />} />
            <Route path="/pdp-concept" element={<PdpConcept />} />
            <Route path="/pdp-concept-v2" element={<PdpConceptV2 />} />
            <Route path="/pdp-concept-v3" element={<PdpConceptV3 />} />
            <Route path="/pdp-concept-v3-1" element={<PdpConceptV31 />} />
            <Route path="/pdp-concept-v3-2" element={<PdpConceptV32 />} />
            <Route path="/pdp-concept-v3-3" element={<PdpConceptV33 />} />
            <Route path="/pdp-concept-v3-4" element={<PdpConceptV34 />} />
          </Routes>
        </BrowserRouter>
      </PasswordGate>
    </div>
  );
}

export default App;
